<script context="module">
    import { env } from '../Environment.svelte';

    export async function validateOffer(postalCode, latitude, longitude) {
        const headers = new Headers();
        headers.append('x-api-key', env?.[env?.stage]?.api?.key);
        headers.append('Content-Type', 'application/json');

        const body = JSON.stringify({
            postalCode: postalCode,
            latitude: latitude.toString(),
            longitude: longitude.toString(),
        });
        const response = await fetch(
            env[env.stage].api.url +
                'apikey/izzi/ms/purchaseServices/serviceability/validateOffer',
            {
                method: 'POST',
                headers: headers,
                body: body,
            }
        );

        if (!response.ok) {
            throw new Error(`Error: ${response.status} ${response.statusText}`);
        }
        return response.json();
    }
</script>
